/** Definitions of types to vuex modules */
import Vue from "vue";

export default Vue.extend({
  name: "opendata-module-mixin",
  computed: {
    // opendataのplaceを選んだとき
    isOpendataMixin(): boolean {
      return this.$store.state.data.isOpendata;
    },
    // opendataの避難所市区町村を選んだとき
    isOpendataEvacuationCenterMixin(): boolean {
      return this.$store.getters["data/isOpendataEvacuationCenter"];
    },
    // 避難所マップの場合
    isEvacuationCenterMixin(): boolean {
      return this.$store.state.data.selectedGenre === "evacuation-center";
    },
  },
  methods: {
    setIsOpendataMixin(payload: boolean) {
      this.$store.commit("data/setIsOpendata", payload);
    },
  },
});
